import { DestroyRef, Injectable, NgZone } from '@angular/core';
import { posthog as posthogLib, PostHogInterface } from 'posthog-js';
import { environment } from '../../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SiteDeploymentType } from '@myrtls/api-interfaces';

@Injectable({ providedIn: 'root' })
export class PosthogService {
    posthog?: PostHogInterface;

    constructor(
        private ngZone: NgZone,
        private router: Router,
        private destroyRef: DestroyRef,
    ) {
        this.initPostHog();
    }

    private initPostHog() {
        this.ngZone.runOutsideAngular(() => {
            if (environment.deployment === SiteDeploymentType.CLOUD) {
                posthogLib.init(environment.analytics.key, {
                    api_host: environment.analytics.host,
                    debug: false,
                    cross_subdomain_cookie: true,
                    person_profiles: 'identified_only',
                    capture_pageview: false,
                    capture_pageleave: true,
                    loaded: posthogInstance => {
                        this.posthog = posthogInstance;
                        this.router.events
                            .pipe(
                                filter(event => event instanceof NavigationEnd),
                                takeUntilDestroyed(this.destroyRef),
                            )
                            .subscribe(() => {
                                posthogInstance.capture('$pageview');
                            });
                    },
                });
            }
        });
    }
}
